import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MyProfileComponent } from "./my-profile/my-profile.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { MyAccountComponent } from "./my-account.component";
import { EditProfileComponent } from './my-profile/edit-profile/edit-profile.component';
import { MySubscriptionComponent } from './my-subscription/my-subscription.component';
import { SavedCardComponent } from './saved-card/saved-card.component';

const routes: Routes = [
  {
    path: "",
    component: MyAccountComponent,
    children: [
      {
        path: "",
        component: MyProfileComponent
      },
      {
        path: "profile",
        component: MyProfileComponent
      },
      {
        path: "change-password",
        component: ChangePasswordComponent
      },
      {
        path: "my-subscription",
        component: MySubscriptionComponent
      },
      {
        path: "saved-card",
        component: SavedCardComponent
      },
      {
        path: "edit-profile",
        component: EditProfileComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyAccountRoutingModule {}
